import { media } from '@/utils/viewports';
import Link from 'next/link';
import styled, { css } from 'styled-components';

export const HelpPageContainer = styled.div`
  padding: 4rem;
  border-radius: 8px;
  background: ${props => props.theme.help.background};
  margin: 0 0 3rem 0;

  ${media.m} {
    border-radius: 0;
    background: white;
    margin: 0;
  }
`;

export const MenuTitlesContainer = styled.div`
  display: flex;
  flex-direction: row;

  ${media.m} {
    justify-content: center;
  }
`;

export const Title = styled(Link)<{
  $isFaqs: boolean;
  $isCurrentPage: boolean;
}>`
  text-decoration: none;
  font-family: ${props => props.theme.help.fontFamilyTitle};
  color: ${props => props.theme.help.titleColor};
  text-align: left;
  font-size: ${props => props.theme.help.fontSizeTitle};
  font-weight: ${props => props.theme.help.fontWeightTitle};
  line-height: ${props => props.theme.help.lineHeightTitle};
  letter-spacing: 0em;
  margin-bottom: 1rem;
  text-transform: ${props => props.theme.help.textTransformTitle};

  border-bottom: ${({ $isCurrentPage }) =>
    $isCurrentPage && (props => props.theme.help.helpMenu.border)};
  padding-bottom: ${({ $isCurrentPage }) => $isCurrentPage && '10px'};

  &:last-of-type {
    margin-left: 6rem;
  }

  &:hover {
    border-bottom: ${({ $isCurrentPage }) =>
      !$isCurrentPage && (props => props.theme.help.helpMenu.hoverBorderColor)};
    padding-bottom: ${({ $isCurrentPage }) => $isCurrentPage && '10px'};
    color: ${({ $isCurrentPage }) =>
      !$isCurrentPage && (props => props.theme.help.textColor)};
  }

  ${media.m} {
    font-size: 28px;
    display: ${({ $isFaqs }) => ($isFaqs ? 'none' : 'block')};
  }
`;

export const SmallTitle = styled(Link)<{
  $isFaqs: boolean;
  $isCurrentPage: boolean;
}>`
  text-decoration: none;
  font-family: ${props => props.theme.help.fontFamilyTitle};
  color: ${props => props.theme.help.titleColor};
  text-align: left;
  font-weight: 300;
  letter-spacing: 0em;
  line-height: 1px;
  font-size: 1px;
  opacity: 0;
  border-bottom: ${({ $isCurrentPage }) =>
    $isCurrentPage && (props => props.theme.help.helpMenu.border)};
  padding-bottom: ${({ $isCurrentPage }) => $isCurrentPage && '10px'};

  ${media.m} {
    ${({ $isFaqs }) =>
      $isFaqs &&
      css`
        line-height: 51px;
        font-size: 28px;
        opacity: 1;
      `}
  }
`;

export const Description = styled.p`
  font-family: ${props => props.theme.help.fontFamilyText};
  font-size: ${props => props.theme.help.fontSizeText};
  font-style: normal;
  font-weight: ${props => props.theme.help.fontWeightText};
  line-height: 150%;
  text-align: left;
  color: ${props => props.theme.help.textColor};

  ${media.m} {
    padding: 2rem 3rem;
    border-radius: 8px;
    background: ${props => props.theme.help.background};
  }

  &:not(:first-child) {
    margin: 3rem 0 0 0;

    ${media.m} {
      margin: 2rem 0 0 0;
    }
  }
`;
